import { createContext } from 'react';
import { OwnerContractDetail } from '@/custom-types';

export type OwnerContractDetailsContextProps = {
  contract: OwnerContractDetail | undefined,
  setContract: (contract: OwnerContractDetail | undefined) => void
}

export const OwnerContractDetailsContext = createContext<OwnerContractDetailsContextProps | null>(null)
